import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec1bc76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = {
  class: "panel-body",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { style: {"min-width":"90px","min-height":"90px"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Numar", -1))
const _hoisted_10 = {
  class: "text__title--medium",
  style: {"padding-left":"5px"}
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  class: "col-md-7",
  style: {"padding-right":"5px"}
}
const _hoisted_13 = { class: "table table-nocondensed" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Status:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_16 = { class: "text__input--medium bg-white" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Categorie: ", -1))
const _hoisted_18 = { class: "text__input--medium bg-white" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Tip: ", -1))
const _hoisted_20 = { class: "text__input--medium bg-white" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Denumire:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_23 = { class: "text__input--medium bg-white" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Descriere:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_25 = { class: "text__input--medium bg-white" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Locatie:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_27 = { class: "text__input--medium bg-white" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Latitudine:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_30 = { class: "text__input--medium bg-white" }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Longitudine:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_33 = { class: "text__input--medium bg-white" }
const _hoisted_34 = { key: 4 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "GPS:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_36 = { class: "text__input--medium bg-white" }
const _hoisted_37 = { key: 5 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "ID intern / nr inventar:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_39 = { class: "text__input--medium bg-white" }
const _hoisted_40 = { class: "text__title--medium" }
const _hoisted_41 = { style: {"display":"flex"} }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons",
  style: {"margin-left":"auto"}
}, "create", -1))
const _hoisted_45 = { class: "text__input--medium bg-white" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Org Unit:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "material-icons",
      style: {"margin-left":"auto"}
    }, "create")
  ])
], -1))
const _hoisted_47 = { class: "text__input--medium bg-white" }
const _hoisted_48 = { class: "text__title--medium" }
const _hoisted_49 = { style: {"display":"flex"} }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons",
  style: {"margin-left":"auto"}
}, "create", -1))
const _hoisted_53 = { class: "text__input--medium bg-white" }
const _hoisted_54 = {
  class: "col-md-5",
  style: {"padding-left":"2em","display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"center"}
}
const _hoisted_55 = { style: {"display":"flex","align-items":"center","justify-content":"flex-start","width":"100%"} }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Galerie", -1))
const _hoisted_57 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_60 = {
  key: 1,
  style: {"width":"90%"}
}
const _hoisted_61 = {
  key: 0,
  class: "q-pa-xs"
}
const _hoisted_62 = { style: {"flex-direction":"row","display":"flex","flex-wrap":"wrap","max-height":"200px","overflow-x":"scroll"} }
const _hoisted_63 = ["name", "img-src"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%","border-bottom":"1px solid black"} }, null, -1))
const _hoisted_66 = { style: {"display":"flex","align-items":"center","justify-content":"flex-start","width":"100%"} }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente", -1))
const _hoisted_68 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_71 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_74 = { class: "mobile-only" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%","border-bottom":"1px solid black"} }, null, -1))
const _hoisted_77 = { style: {"display":"flex","align-items":"left","justify-content":"left","width":"100%"} }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Planificari")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_81 = {
  style: {"max-width":"30vw"},
  class: "container--span__file_scan"
}
const _hoisted_82 = {
  key: 0,
  class: "cursor-pointer"
}
const _hoisted_83 = {
  class: "q-pa-md",
  style: {"min-width":"30vw"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "share", -1))
const _hoisted_85 = {
  class: "row",
  style: {"display":"flex","max-width":"450px","width":"100%","margin-left":"5px"}
}
const _hoisted_86 = {
  class: "col-8",
  style: {"text-align":"left"}
}
const _hoisted_87 = { key: 1 }
const _hoisted_88 = { style: {"color":"rgb(134, 134, 134)"} }
const _hoisted_89 = {
  style: {"max-width":"30vw"},
  class: "container--span__file_scan"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons rotated90" }, "attachment", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editeaza", -1))
const _hoisted_92 = {
  class: "q-pa-md",
  style: {"min-width":"30vw","align-items":"center"}
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sunteti sigur sa preluati acest plan sau incident?", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Acest plan sau incident este preluat deja!", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Preia in lucru", -1))
const _hoisted_96 = {
  class: "q-pa-md",
  style: {"min-width":"30vw","align-items":"center"}
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Setati ca si terminat acest plan?", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Acest plan sau incident este finalizat!", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Finalizeaza", -1))
const _hoisted_100 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_101 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_103 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Adaugare plan", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Galerie", -1))
const _hoisted_106 = { class: "absolute-top custom-caption" }
const _hoisted_107 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_ComboUser = _resolveComponent("ComboUser")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_ComboOrgUnit = _resolveComponent("ComboOrgUnit")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditAssetNotification = _resolveComponent("EditAssetNotification")!
  const _component_q_carousel_control = _resolveComponent("q-carousel-control")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingAssetData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", { src: _ctx.getLinkToQrCode }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                  }, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.assetApp.id_asset), 1)
                  ], 2),
                  _createVNode(_component_q_btn, {
                    color: "white",
                    "text-color": "black",
                    "icon-right": "print",
                    label: "Tipareste!",
                    disable: _ctx.loadingPdfForDownload,
                    "no-caps": "",
                    loading: _ctx.loadingPdfForDownload,
                    onClick: _ctx.prepareCoverPdfForDownload
                  }, {
                    loading: _withCtx(() => [
                      _createVNode(_component_q_spinner_gears, { class: "on-right" }),
                      _createTextVNode(" Pregatire... ")
                    ]),
                    _: 1
                  }, 8, ["disable", "loading", "onClick"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("tbody", null, [
                    ((!(_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) || (!['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("td", _hoisted_16, [
                            _createTextVNode(_toDisplayString(_ctx.getDenStatus(_ctx.assetApp.status as string)) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.assetApp.status,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetApp.status) = $event)),
                              validate: val => val.length > 0
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_select, {
                                  outlined: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  options: _ctx.optionsStatus,
                                  style: {"min-width":"300px"},
                                  "option-value": "status",
                                  "option-label": "label",
                                  "emit-value": "",
                                  "map-options": "",
                                  "lazy-rules": "",
                                  dense: "",
                                  autofocus: "",
                                  hint: "Modificare stare",
                                  "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                  rules: [ val => val && val.length > 0 || 'Alegeti tipul de stare!']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateStatus(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "options", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.assetApp.denumire_categ_active) + " ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_19,
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.getDenTipActive(_ctx.assetApp.appid_tip_active as number)) + " ", 1)
                    ]),
                    ((!(_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) || (!['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("td", _hoisted_23, [
                            _createTextVNode(_toDisplayString(_ctx.assetApp.titlu) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.assetApp.titlu,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.assetApp.titlu) = $event)),
                              validate: val => val.length > 0
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"300px"},
                                  value: _ctx.assetApp.titlu,
                                  hint: "Modificare denumire",
                                  maxlength: "100",
                                  "lazy-rules": "",
                                  rules: [ val => val && val.length > 0 || 'Completati denumire!']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateTitlu(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_24,
                      _createElementVNode("td", _hoisted_25, [
                        _createTextVNode(_toDisplayString(_ctx.assetApp.descriere) + " ", 1),
                        _createVNode(_component_q_popup_edit, {
                          modelValue: _ctx.assetApp.descriere,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.assetApp.descriere) = $event)),
                          validate: val => val.length > 0
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_q_input, {
                              autofocus: "",
                              dense: "",
                              modelValue: scope.value,
                              "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                              style: {"min-width":"400px"},
                              value: _ctx.assetApp.descriere,
                              hint: "Modificare descriere",
                              maxlength: "1000",
                              "lazy-rules": "",
                              rows: "3",
                              type: "textarea",
                              rules: [ val => val && val.length > 0 || 'Completati descriere!']
                            }, {
                              after: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "cancel",
                                  onClick: _withModifiers(scope.cancel, ["stop"])
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "positive",
                                  icon: "check_circle",
                                  onClick: _withModifiers(($event: any) => (_ctx.tryUpdateDescriere(scope)), ["stop"]),
                                  disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                }, null, 8, ["onClick", "disable"])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "validate"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_26,
                      _createElementVNode("td", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_ctx.assetApp.geo_text) + " ", 1),
                        _createVNode(_component_q_popup_edit, {
                          modelValue: _ctx.assetApp.geo_text,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assetApp.geo_text) = $event)),
                          validate: val => val.length > 0
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_q_input, {
                              autofocus: "",
                              dense: "",
                              modelValue: scope.value,
                              "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                              style: {"min-width":"300px"},
                              value: _ctx.assetApp.geo_text,
                              hint: "Modificare locatie",
                              maxlength: "100",
                              "lazy-rules": "",
                              rules: [ val => val && val.length > 0 || 'Completati locatia!']
                            }, {
                              after: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "cancel",
                                  onClick: _withModifiers(scope.cancel, ["stop"])
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "positive",
                                  icon: "check_circle",
                                  onClick: _withModifiers(($event: any) => (_ctx.tryUpdateLocatie(scope)), ["stop"]),
                                  disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                }, null, 8, ["onClick", "disable"])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "validate"])
                      ])
                    ]),
                    ((!(_ctx.assetApp.denumire_categ_active == 'IOT' || _ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) || (!['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("td", _hoisted_30, [
                            _createTextVNode(_toDisplayString(_ctx.assetApp.geo_lat) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.assetApp.geo_lat,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.assetApp.geo_lat) = $event))
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"300px"},
                                  value: _ctx.assetApp.geo_lat,
                                  hint: "Modificare latitudine",
                                  maxlength: "100",
                                  "lazy-rules": "",
                                  mask: "##.######"
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateLatitudine(scope)), ["stop"]),
                                      disable: scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((!(_ctx.assetApp.denumire_categ_active == 'IOT' || _ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) || (!['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("td", _hoisted_33, [
                            _createTextVNode(_toDisplayString(_ctx.assetApp.geo_long) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.assetApp.geo_long,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assetApp.geo_long) = $event))
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"300px"},
                                  value: _ctx.assetApp.geo_long,
                                  hint: "Modificare longitudine",
                                  maxlength: "100",
                                  "lazy-rules": "",
                                  mask: "##.######"
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateLongitudine(scope)), ["stop"]),
                                      disable: scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.assetApp.denumire_categ_active == 'Flota'  && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("td", _hoisted_36, [
                            _createTextVNode(_toDisplayString(_ctx.getDenStatusGPS(_ctx.gpsStatus as string)) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.gpsStatus,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gpsStatus) = $event)),
                              validate: val => val.length > 0
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_select, {
                                  outlined: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  options: _ctx.optionsStatusGPS,
                                  style: {"min-width":"300px"},
                                  "option-value": "status",
                                  "option-label": "label",
                                  "emit-value": "",
                                  "map-options": "",
                                  "lazy-rules": "",
                                  dense: "",
                                  autofocus: "",
                                  hint: "Modificare stare gps",
                                  "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                  rules: [ val => val && val.length > 0 || 'Alegeti stare gps!']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateStatusGPS(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "options", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((!(_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) || (!['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("td", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.assetApp.nr_inventare) + " ", 1),
                            _createVNode(_component_q_popup_edit, {
                              modelValue: _ctx.assetApp.nr_inventare,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.assetApp.nr_inventare) = $event)),
                              validate: val => val.length > 0
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"300px"},
                                  value: _ctx.assetApp.nr_inventare,
                                  hint: "Modificare numar de inventar",
                                  maxlength: "100",
                                  "lazy-rules": "",
                                  rules: [ val => val && val.length > 0 || 'Completati numar de inventar!']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateNumarInventar(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          (((_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, " Data programarii: "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_43, "Data achizitie:")),
                          _hoisted_44
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.assetApp.data_achizitie) + " ", 1),
                        _createVNode(_component_q_popup_edit, {
                          modelValue: _ctx.assetApp.data_achizitie,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.assetApp.data_achizitie) = $event)),
                          validate: val => val.length > 0
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_q_input, {
                              outlined: "",
                              modelValue: scope.value,
                              "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                              dense: "",
                              mask: "##.##.####",
                              "emit-value": "",
                              autofocus: "",
                              label: ((_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)) ? 'Data programarii' : 'Data achizitie',
                              value: _ctx.assetApp.data_achizitie,
                              hint: ((_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'Modificare data programarii' : 'Modificare data achizitie'),
                              "lazy-rules": "",
                              style: {"min-width":"300px"},
                              rules: [ val => val && val.length > 0 || ((_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME) ? 'Completati data programarii!' : 'Completati data achizitie!')]
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "event",
                                  class: "cursor-pointer"
                                })
                              ]),
                              after: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "cancel",
                                  onClick: _withModifiers(scope.cancel, ["stop"])
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  dense: "",
                                  color: "positive",
                                  icon: "check_circle",
                                  onClick: _withModifiers(($event: any) => (_ctx.tryUpdateDataAchizitie(scope)), ["stop"]),
                                  disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                }, null, 8, ["onClick", "disable"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_q_popup_proxy, {
                                  ref: "qDateProxy0",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_date, {
                                      minimal: "",
                                      modelValue: scope.value,
                                      "onUpdate:modelValue": [
                                        ($event: any) => ((scope.value) = $event),
                                        _cache[8] || (_cache[8] = ($event: any) => ((_ctx.$refs['qDateProxy0'] as any).hide()))
                                      ],
                                      mask: "DD.MM.YYYY",
                                      locale: _ctx.myLocale
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"])
                                  ]),
                                  _: 2
                                }, 1536)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "label", "value", "hint", "rules"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "validate"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_46,
                      _createElementVNode("td", _hoisted_47, [
                        _createVNode(_component_q_input, {
                          outlined: "",
                          autofocus: "",
                          dense: "",
                          style: {"min-width":"300px"},
                          modelValue: _ctx.assetApp.denumire_org_unit,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.assetApp.denumire_org_unit) = $event)),
                          "lazy-rules": "",
                          readonly: "",
                          "no-parent-event": "",
                          onClick: _ctx.inputOrgUnit,
                          ref: "refOrgUnit"
                        }, null, 8, ["modelValue", "onClick"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          (((_ctx.assetApp.denumire_categ_active == 'Medicina muncii' || _ctx.assetApp.denumire_categ_active == 'Telemedicina') && ['APP_BRANDTEAM'].includes(_ctx.APP_NAME)))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Angajat "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_51, "Persoana responsabila:")),
                          _hoisted_52
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_53, [
                        _createVNode(_component_q_input, {
                          outlined: "",
                          autofocus: "",
                          dense: "",
                          style: {"min-width":"300px"},
                          modelValue: _ctx.assetApp.den_user_deponent,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.assetApp.den_user_deponent) = $event)),
                          "lazy-rules": "",
                          readonly: "",
                          "no-parent-event": "",
                          onClick: _ctx.inputPersoana,
                          ref: "refPersoana"
                        }, null, 8, ["modelValue", "onClick"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", null, [
                    _hoisted_56,
                    _withDirectives(_createElementVNode("div", _hoisted_57, "Nimic atasat", 512), [
                      [_vShow, _ctx.assetApp.scan_galeries != null && _ctx.assetApp.scan_galeries.length==0 && !_ctx.uploadingFileToServer]
                    ])
                  ]),
                  (_ctx.user.auth_for_upload_scan=='y' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          color: "primary",
                          icon: "add_box",
                          "no-caps": "",
                          disable: _ctx.loadingAssetData,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openFormUploadFile('n')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, {
                              "transition-show": "rotate",
                              "transition-hide": "rotate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Incarca galerie nou ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.uploadingFileToServer)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 0,
                        color: "primary",
                        size: "3em",
                        thickness: 10
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        (Number(_ctx.assetApp.scan_galeries?.length) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetApp.scan_galeries, (scan_galerie, key) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: scan_galerie.appid,
                                    name: key,
                                    "img-src": _ctx.getLinkToImgAsset(scan_galerie.appid?.toString())
                                  }, [
                                    _createVNode(_component_q_img, {
                                      src: _ctx.getLinkToImgAsset(scan_galerie.appid?.toString()),
                                      style: {"min-height":"65px","max-height":"65px","min-width":"65px","max-width":"65px","margin":"10px"},
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => ( _ctx.onPressFullScreen()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          class: "absolute all-pointer-events",
                                          size: "16px",
                                          name: "delete_forever",
                                          color: "red",
                                          style: {"top":"1px","left":"1px"},
                                          onClick: _withModifiers(($event: any) => (_ctx.askIfRemoveScan(scan_galerie)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Sterge ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["src"])
                                  ], 8, _hoisted_63))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_64
                      ]))
                ]),
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", null, [
                    _hoisted_67,
                    _withDirectives(_createElementVNode("div", _hoisted_68, "Nimic atasat", 512), [
                      [_vShow, _ctx.assetApp.scan_documents != null && _ctx.assetApp.scan_documents.length==0 && !_ctx.uploadingFileToServer]
                    ])
                  ]),
                  (_ctx.user.auth_for_upload_scan=='y' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          color: "primary",
                          icon: "add_box",
                          "no-caps": "",
                          disable: _ctx.loadingAssetData,
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openFormUploadFile('y')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, {
                              "transition-show": "rotate",
                              "transition-hide": "rotate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Incarca document nou ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  (_ctx.uploadingFileToServer)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 0,
                        color: "primary",
                        size: "3em",
                        thickness: 10
                      }))
                    : (_openBlock(), _createElementBlock("table", _hoisted_71, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetApp.scan_documents, (scan_document) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: scan_document.appid
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: "material-icons cursor-pointer",
                                  style: {"color":"red","font-size":"1.3rem"},
                                  onClick: ($event: any) => (_ctx.askIfRemoveScan(scan_document))
                                }, "delete_forever", 8, _hoisted_72)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(scan_document.file_ext), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan_document.file_size)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_73, _toDisplayString(scan_document.description), 1),
                                _createElementVNode("div", _hoisted_74, _toDisplayString(scan_document.description), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_q_btn, {
                                  round: "",
                                  color: "black",
                                  icon: "cloud_download",
                                  size: "xs"
                                }),
                                _createVNode(_component_q_menu, {
                                  fit: "",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DialogOpenScan, {
                                      appid: scan_document.appid,
                                      type_scan: "Asset"
                                    }, null, 8, ["appid"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "primary",
                    icon: "add_box",
                    "no-caps": "",
                    disable: _ctx.loadingAssetData,
                    onClick: _ctx.openFormAssetPlan
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Adaugare plan nou ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disable", "onClick"])
                ]),
                _hoisted_79
              ]),
              _createElementVNode("div", _hoisted_80, [
                (_ctx.loadingNotification)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 0,
                      color: "primary",
                      size: "3em",
                      thickness: 10
                    }))
                  : (_openBlock(), _createBlock(_component_q_table, {
                      key: 1,
                      dense: "",
                      "rows-per-page-options": [0],
                      rows: _ctx.notifications,
                      columns: _ctx.assetsNotificationListColumns,
                      "visible-columns": _ctx.visibleAssetsNotificationListColumns,
                      "row-key": "appid",
                      filter: _ctx.filterAssetsNotificationList,
                      loading: _ctx.loadingNotification,
                      pagination: _ctx.myPagination,
                      class: "table table-bordered table-condensed table-responsive"
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_input, {
                          dense: "",
                          debounce: "300",
                          color: "primary",
                          modelValue: _ctx.filterAssetsNotificationList,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filterAssetsNotificationList) = $event))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "search" })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "appid",
                              props: props,
                              sortable: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.appid), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "state_notification",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "lens",
                                  style: {"font-size":"25px"},
                                  class: _normalizeClass({
                                            'app__status--gray': (props.row.state_notification == 'gray'),
                                            'app__status--green': (props.row.state_notification == 'green'),
                                            'app__status--yellow': (props.row.state_notification == 'yellow'),
                                            'app__status--red': (props.row.state_notification == 'red'),
                                            'app__status--blue': (props.row.state_notification == 'blue')
                                        })
                                }, null, 8, ["class"])
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_categorie_active",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_categorie_active), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_tip_active",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_tip_active), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_asset",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_asset), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "solicitant",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.solicitant), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_eveniment",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_eveniment), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "descriere",
                              props: props,
                              sortable: true,
                              Style: "white-space:pre-wrap; word-wrap:break-word"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.descriere), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_utilizatori",
                              props: props,
                              sortable: true,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_81, [
                                  (props.row.denumire_utilizatori?.length > 0 && props.row.denumire_utilizatori?.split(',')?.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                        _createVNode(_component_q_badge, {
                                          color: "blue",
                                          transparent: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.row.denumire_utilizatori.split(',').length) + " ", 1),
                                            _createVNode(_component_q_menu, {
                                              fit: "",
                                              "transition-show": "scale",
                                              "transition-hide": "scale"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_83, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.denumire_utilizatori.split(','), (utilizator) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                      key: utilizator,
                                                      class: "span__repartizare"
                                                    }, [
                                                      _hoisted_84,
                                                      _createElementVNode("div", _hoisted_85, [
                                                        _createElementVNode("div", _hoisted_86, _toDisplayString(utilizator), 1)
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                        _createElementVNode("span", _hoisted_88, _toDisplayString(props.row.denumire_utilizatori), 1)
                                      ]))
                                ])
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "data_termen",
                              props: props,
                              sortable: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.displayData(props.row.data_termen)), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "denumire_stare",
                              props: props,
                              sortable: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.denumire_stare), 1)
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "scans",
                              props: props,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_89, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.scans, (scan) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: scan.appid,
                                      class: "cursor-pointer span__file_scan"
                                    }, [
                                      _hoisted_90,
                                      _createTextVNode(" " + _toDisplayString(_ctx.humanReadableBytes(scan.file_size)) + "." + _toDisplayString(scan.file_ext) + " ", 1),
                                      _createVNode(_component_q_menu, {
                                        fit: "",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DialogOpenScan, {
                                            appid: scan.appid,
                                            type_scan: "AssetNotification"
                                          }, null, 8, ["appid"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1032, ["props"]),
                            _createVNode(_component_q_td, {
                              key: "appid",
                              props: props,
                              sortable: false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: 'edit',
                                  class: _normalizeClass(props.row.status === 'n' && props.row.appid_users?.includes(_ctx.userStore.User.userid) ? 'text-blue cursor-pointer pencil' : 'text-light cursor-pointer pencil'),
                                  style: {"font-size":"1.2rem","margin-left":"auto"},
                                  onClick: ($event: any) => (props.row.appid_users?.includes(_ctx.userStore.User.userid) && props.row.status === 'n' && _ctx.onPressEditRowAssetNotification(props.row))
                                }, {
                                  default: _withCtx(() => [
                                    (props.row.appid_users?.includes(_ctx.userStore.User.userid) && props.row.status == 'n')
                                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _hoisted_91
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"]),
                                _createVNode(_component_q_icon, {
                                  name: props.row.appid_user_alocat ? 'person' : 'person_add_alt',
                                  class: _normalizeClass(props.row.appid_users?.includes(_ctx.userStore.User.userid) && props.row.status === 'n' ? (props.row.appid_user_alocat ? 'text-orange cursor-pointer pencil' : 'text-blue cursor-pointer pencil') : 'text-light'),
                                  style: {"font-size":"1.2rem","margin-left":"1vh"}
                                }, {
                                  default: _withCtx(() => [
                                    ((props.row.appid_users?.includes(_ctx.userStore.User.userid) && (props.row.appid_user_alocat == null || props.row.appid_user_alocat != _ctx.userStore.User.userid) && props.row.status == 'n'))
                                      ? (_openBlock(), _createBlock(_component_q_menu, {
                                          key: 0,
                                          fit: "",
                                          "transition-show": "scale",
                                          "transition-hide": "scale",
                                          "min-width": "50vh",
                                          "max-width": "100vh"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_92, [
                                              _hoisted_93,
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                flat: "",
                                                dense: "",
                                                color: "negative",
                                                icon: "cancel"
                                              }, null, 512), [
                                                [_directive_close_popup]
                                              ]),
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                flat: "",
                                                dense: "",
                                                color: "positive",
                                                icon: "check_circle",
                                                onClick: _withModifiers(($event: any) => (_ctx.updateUserAlocat(props.row)), ["stop"])
                                              }, null, 8, ["onClick"]), [
                                                [_directive_close_popup]
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    (props.row.appid_user_alocat == _ctx.userStore.User.userid && props.row.status == 'n')
                                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _hoisted_94
                                          ]),
                                          _: 1
                                        }))
                                      : (props.row.appid_users?.includes(_ctx.userStore.User.userid) && props.row.status == 'n')
                                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 2 }, {
                                            default: _withCtx(() => [
                                              _hoisted_95
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["name", "class"]),
                                _createVNode(_component_q_icon, {
                                  name: props.row.status === 'n' ? 'check_circle_outline' : 'check',
                                  class: _normalizeClass(props.row.appid_users?.includes(_ctx.userStore.User.userid) ? (props.row.status === 'n' ? 'text-blue cursor-pointer pencil' : 'text-green cursor-pointer pencil') : 'text-light cursor-pointer pencil'),
                                  style: {"font-size":"1.2rem","margin-left":"1vh"}
                                }, {
                                  default: _withCtx(() => [
                                    (props.row.appid_user_alocat === _ctx.userStore.User.userid && props.row.status === 'n')
                                      ? (_openBlock(), _createBlock(_component_q_menu, {
                                          key: 0,
                                          fit: "",
                                          "transition-show": "scale",
                                          "transition-hide": "scale",
                                          "min-width": "50vh",
                                          "max-width": "100vh"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_96, [
                                              _hoisted_97,
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                flat: "",
                                                dense: "",
                                                color: "negative",
                                                icon: "cancel"
                                              }, null, 512), [
                                                [_directive_close_popup]
                                              ]),
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                flat: "",
                                                dense: "",
                                                color: "positive",
                                                icon: "check_circle",
                                                onClick: _withModifiers(($event: any) => (_ctx.updateAssetNotificationStatus(props.row)), ["stop"])
                                              }, null, 8, ["onClick"]), [
                                                [_directive_close_popup]
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    (props.row.appid_user_alocat == _ctx.userStore.User.userid && props.row.status === 'y')
                                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _hoisted_98
                                          ]),
                                          _: 1
                                        }))
                                      : (props.row.appid_users?.includes(_ctx.userStore.User.userid) && props.row.status == 'n' && props.row.appid_user_alocat)
                                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 2 }, {
                                            default: _withCtx(() => [
                                              _hoisted_99
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["name", "class"])
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]))
              ])
            ])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.viewDialogSelectPersoana,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.viewDialogSelectPersoana) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"70vw"},
          class: _normalizeClass({ 'partial80_height': _ctx.$q.platform.is.mobile, 'partial60_height': _ctx.$q.platform.is.desktop })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.viewDialogSelectPersoana=false)),
                style: {"color":"#747474","font-weight":"bolder","font-size":"1.5em"}
              }, "close")
            ]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_ComboUser, {
                  selectHandler: _ctx.selectPersoana,
                  title: "Selectati persoana responsabil"
                }, null, 8, ["selectHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.viewDialogSelectOrgUnit,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.viewDialogSelectOrgUnit) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"70vw"},
          class: _normalizeClass({ 'partial80_height': _ctx.$q.platform.is.mobile, 'partial60_height': _ctx.$q.platform.is.desktop })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.viewDialogSelectOrgUnit=false)),
                style: {"color":"#747474","font-weight":"bolder","font-size":"1.5em"}
              }, "close")
            ]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_ComboOrgUnit, {
                  selectHandler: _ctx.selectOrgUnit,
                  title: "Selectati Org Unit"
                }, null, 8, ["selectHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length>3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.uploadFile())),
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogNotification,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.visibleDialogNotification) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "add_box" }),
                _hoisted_104,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_EditAssetNotification, {
                  frenunt: _ctx.renuntEditareAssetNotification,
                  fonsave: _ctx.getNotifications,
                  appid_asset: _ctx.assetApp.appid,
                  appid: _ctx.appid_notification
                }, null, 8, ["frenunt", "fonsave", "appid_asset", "appid"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogCarouselFullScreen,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.visibleDialogCarouselFullScreen) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "add_box" }),
                _hoisted_105,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_carousel, {
                  swipeable: "",
                  modelValue: _ctx.slide,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.slide) = $event)),
                  arrows: "",
                  thumbnails: "",
                  height: "100",
                  style: {"min-width":"40vw","max-width":"80vw","min-height":"40vw"}
                }, {
                  control: _withCtx(() => [
                    _createVNode(_component_q_carousel_control, {
                      position: "top-right",
                      offset: [10, 10]
                    })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetApp.scan_galeries, (scan_galerie, key) => {
                      return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                        key: scan_galerie.appid,
                        name: key,
                        "img-src": _ctx.getLinkToImgAsset(scan_galerie.appid?.toString())
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("span", {
                              class: "material-icons cursor-pointer",
                              style: {"margin-top":"10px","margin-left":"10px","color":"red","font-size":"1.5rem"},
                              onClick: ($event: any) => (_ctx.askIfRemoveScan(scan_galerie))
                            }, "delete_forever", 8, _hoisted_107)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["name", "img-src"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetApp.scan_galeries, (scan_galerie, key) => {
                      return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                        key: scan_galerie.appid,
                        name: key,
                        "img-src": _ctx.getLinkToImgAsset(scan_galerie.appid?.toString())
                      }, null, 8, ["name", "img-src"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}